import { createFileRoute, redirect } from '@tanstack/react-router'
import { parse } from 'valibot'

import { buildFetchTruckTypesQuery } from '@/features/truck-types'
import { fetchTruckTypesList } from '@/features/truck-types/api'

import { TruckTypesSearchSchema } from './-models/truck-types-search-schema'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings/truck-types/'
)({
  validateSearch: (search) => parse(TruckTypesSearchSchema, search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ search, location }) => {
    // クエリの有無で初回アクセスかどうかを判定
    const keys = Object.keys(search)

    // 初回アクセス（クエリが空）の場合は、enable=true を既定付与
    if (keys.length === 0) {
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          enable: true
        }
      })
    }
  },
  loader: async ({
    abortController,
    params: { tenantKey },
    deps,
    context: { auth }
  }) => {
    const query = buildFetchTruckTypesQuery(tenantKey, deps)

    const truckTypes = await fetchTruckTypesList(query, abortController.signal)
    return {
      authUser: auth.user,
      truckTypes: truckTypes.data,
      pagination: truckTypes.pagination
    }
  }
})
